export function RMAnalytics(trackingConfigList) {
  this.debugMode = false;
  this.dryRun = false;
  this.trackingConfigList = trackingConfigList;
  this.lastPageView = null;

  this.customMap = {
    dimension1: RMAnalytics.CustomDimension.SETUP_ID,
    dimension2: RMAnalytics.CustomDimension.SETUP_TYPE,
    dimension3: RMAnalytics.CustomDimension.FLIGHT_PATH,
    dimension4: RMAnalytics.CustomDimension.FLIGHT_ID,
  };
}

RMAnalytics.CustomDimension = {};
RMAnalytics.CustomDimension.SETUP_ID = "setup_id";
RMAnalytics.CustomDimension.SETUP_TYPE = "setup_type";
RMAnalytics.CustomDimension.FLIGHT_PATH = "flight_path";
RMAnalytics.CustomDimension.FLIGHT_ID = "flight_identifier";

RMAnalytics.PageView = {};
RMAnalytics.PageView.START = { title: "Start View", path: "/start" };
RMAnalytics.PageView.DESTINATIONS_FOR_AIRPORT = {
  title: "Destinations For Airport",
  path: "/start/destinations",
};
RMAnalytics.PageView.SEARCH_RESULTS = {
  title: "Search Results",
  path: "/searchresults",
};
RMAnalytics.PageView.FLIGHT_DETAIL = {
  title: "Flight Detail",
  path: "/searchresults/flightdetail",
};

RMAnalytics.EventCategory = {};
RMAnalytics.EventCategory.USER = "user";
RMAnalytics.EventCategory.MAP = "map";
RMAnalytics.EventCategory.QUERY = "query";

RMAnalytics.Event = {};
RMAnalytics.Event.FIND_AIRPORTS_SERVED = {
  category: RMAnalytics.EventCategory.QUERY,
  action: "find_airports_served",
};
RMAnalytics.Event.FIND_DESTINATIONS = {
  category: RMAnalytics.EventCategory.QUERY,
  action: "find_destinations",
};
RMAnalytics.Event.FIND_FLIGHTS = {
  category: RMAnalytics.EventCategory.QUERY,
  action: "find_flights",
};
RMAnalytics.Event.MAIN_TILES_LOADED = {
  category: RMAnalytics.EventCategory.MAP,
  action: "main_tiles_loaded",
};
RMAnalytics.Event.POPUP_TILES_LOADED = {
  category: RMAnalytics.EventCategory.MAP,
  action: "popup_tiles_loaded",
};
RMAnalytics.Event.POPUP_MAP_VIEWED = {
  category: RMAnalytics.EventCategory.USER,
  action: "popup_map_viewed",
};
RMAnalytics.Event.PRINT_FLIGHT_DETAIL = {
  category: RMAnalytics.EventCategory.USER,
  action: "print_flight_detail",
};
RMAnalytics.Event.PRINT_FLIGHT_LIST = {
  category: RMAnalytics.EventCategory.USER,
  action: "print_flight_list",
};
RMAnalytics.Event.BOOKING_FLIGHT_LINK = {
  category: RMAnalytics.EventCategory.USER,
  action: "booking_flight_link",
}

RMAnalytics.prototype.sendConfig = function (gaConfigObj) {
  var originalPagePath;
  if (gaConfigObj.hasOwnProperty("page_path")) {
    originalPagePath = gaConfigObj["page_path"];
  } else {
    originalPagePath = null;
  }

  for (var i = 0; i < this.trackingConfigList.length; i++) {
    var currentTrackingConfig = this.trackingConfigList[i];
    if (currentTrackingConfig.hasOwnProperty("id")) {
      var currentTrackingId = currentTrackingConfig["id"];

      if (originalPagePath != null) {
        var pathUse;
        if (currentTrackingConfig.hasOwnProperty("pathBase")) {
          pathUse = currentTrackingConfig["pathBase"] + originalPagePath;
        } else {
          pathUse = originalPagePath;
        }
        gaConfigObj["page_path"] = pathUse;
        gaConfigObj["cookie_flags"] = "SameSite=None;Secure";
      }

      if (!this.dryRun) {
        window.gtag("config", currentTrackingId, gaConfigObj);
      }
      this.log(
        "CONFIG sent: " + currentTrackingId + "; " + JSON.stringify(gaConfigObj)
      );

      // Restore page path...
      if (originalPagePath != null) {
        gaConfigObj["page_path"] = originalPagePath;
      }
    }
  }
};

RMAnalytics.prototype.setup = function (setupId, setupType) {
  var gaConfigObj = {
    custom_map: this.customMap,
    send_page_view: false,
    page_title: RMAnalytics.PageView.START.title,
    page_path: RMAnalytics.PageView.START.path,
  };

  gaConfigObj[RMAnalytics.CustomDimension.SETUP_ID] = setupId;
  gaConfigObj[RMAnalytics.CustomDimension.SETUP_TYPE] = setupType;

  this.sendConfig(gaConfigObj);

  this.log(
    "SETUP performed: " +
      JSON.stringify(this.trackingConfigList) +
      "; " +
      JSON.stringify(gaConfigObj)
  );
};

RMAnalytics.prototype.recordPageView = function (pageView, analyticsObj) {
  if (pageView !== this.lastPageView) {
    if (analyticsObj == null) {
      analyticsObj = {};
    }

    analyticsObj["custom_map"] = this.customMap;
    analyticsObj["page_title"] = pageView.title;
    analyticsObj["page_path"] = pageView.path;

    this.sendConfig(analyticsObj);

    this.lastPageView = pageView;

    this.log(
      "PAGEVIEW recorded: " +
        pageView.title +
        "; " +
        JSON.stringify(analyticsObj)
    );
  }
};

RMAnalytics.prototype.recordEvent = function (event, eventLabel, analyticsObj) {
  if (analyticsObj == null) {
    analyticsObj = {};
  }

  var nonInteraction = event.category !== RMAnalytics.EventCategory.USER;

  analyticsObj["event_category"] = event.category;
  analyticsObj["event_label"] = eventLabel;
  analyticsObj["non_interaction"] = nonInteraction;

  if (!this.dryRun) {
    window.gtag("event", event.action, analyticsObj);
  }

  this.log(
    event.category.toUpperCase() +
      " event: " +
      event.action +
      "... " +
      JSON.stringify(analyticsObj)
  );
};

RMAnalytics.prototype.createAnalyticsObjectFromCbwsRequest = function (
  cbwsRequest
) {
  var analyticsObj;

  if (cbwsRequest != null) {
    var metaDict = {};

    metaDict.aptFrom =
      cbwsRequest.originCriteria && cbwsRequest.originCriteria !== "***"
        ? cbwsRequest.originCriteria
        : null;
    metaDict.aptTo =
      cbwsRequest.destinationCriteria &&
      cbwsRequest.destinationCriteria !== "***"
        ? cbwsRequest.destinationCriteria
        : null;
    metaDict.aptVia =
      cbwsRequest.via1Criteria && cbwsRequest.via1Criteria !== "***"
        ? cbwsRequest.via1Criteria
        : null;

    metaDict.airline =
      cbwsRequest.carrier1Criteria && cbwsRequest.carrier1Criteria !== "***"
        ? cbwsRequest.carrier1Criteria
        : null;
    metaDict.airline2 =
      cbwsRequest.carrier2Criteria && cbwsRequest.carrier2Criteria !== "***"
        ? cbwsRequest.carrier2Criteria
        : null;

    analyticsObj = this.createAnalyticsObjectFromMetaDict(metaDict);
  } else {
    analyticsObj = null;
  }

  return analyticsObj;
};

RMAnalytics.prototype.createAnalyticsObjectFromFlight = function (flight) {
  var analyticsObj;
  if (flight != null) {
    var metaDict = {};

    metaDict.aptFrom =
      flight.depart != null && flight.depart !== "***" ? flight.depart : null;
    metaDict.aptTo =
      flight.arrival != null && flight.arrival !== "***"
        ? flight.arrival
        : null;
    metaDict.aptVia =
      flight.connxLeg1Arrival != null && flight.connxLeg1Arrival !== "***"
        ? flight.connxLeg1Arrival
        : null;
    metaDict.aptVia2 =
      flight.connxLeg2Arrival != null && flight.connxLeg2Arrival !== "***"
        ? flight.connxLeg2Arrival
        : null;

    metaDict.airline = flight.operatedBy != null ? flight.operatedBy : null;
    metaDict.flightNum = flight.flightNo != null ? flight.flightNo : null;

    metaDict.airline2 =
      flight.connxLeg2OperatedBy != null ? flight.connxLeg2OperatedBy : null;
    metaDict.flightNum2 =
      flight.connxLeg2FlightNo != null ? flight.connxLeg2FlightNo : null;

    metaDict.airline3 =
      flight.connxLeg3OperatedBy != null ? flight.connxLeg3OperatedBy : null;
    metaDict.flightNum3 =
      flight.connxLeg3FlightNo != null ? flight.connxLeg3FlightNo : null;

    analyticsObj = this.createAnalyticsObjectFromMetaDict(metaDict);
  } else {
    analyticsObj = null;
  }

  return analyticsObj;
};

RMAnalytics.prototype.createAnalyticsObjectFromMetaDict = function (metaDict) {
  var analyticsObj = {};

  if (metaDict.aptFrom == null || metaDict.aptFrom === "***") {
    metaDict.aptFrom = "???";
  }
  if (metaDict.aptTo == null || metaDict.aptTo === "***") {
    metaDict.aptTo = "???";
  }
  if (metaDict.aptVia == null || metaDict.aptVia === "***") {
    metaDict.aptVia = "???";
  }
  if (metaDict.aptVia2 == null || metaDict.aptVia2 === "***") {
    metaDict.aptVia2 = "???";
  }

  if (metaDict.airline == null || metaDict.airline === "***") {
    metaDict.airline = "???";
  }
  if (metaDict.airline2 == null || metaDict.airline2 === "***") {
    metaDict.airline2 = "???";
  }
  if (metaDict.airline3 == null || metaDict.airline3 === "***") {
    metaDict.airline3 = "???";
  }

  if (metaDict.flightNum == null || metaDict.flightNum === "***") {
    metaDict.flightNum = "???";
  }
  if (metaDict.flightNum2 == null || metaDict.flightNum2 === "***") {
    metaDict.flightNum2 = "???";
  }
  if (metaDict.flightNum3 == null || metaDict.flightNum3 === "***") {
    metaDict.flightNum3 = "???";
  }

  var flightPath = metaDict.aptFrom;

  if (metaDict.aptVia2 !== "???") {
    flightPath += "-" + metaDict.aptVia + "-" + metaDict.aptVia2;
  } else if (metaDict.aptVia !== "???") {
    flightPath += "-" + metaDict.aptVia;
  }

  flightPath += "-" + metaDict.aptTo;

  analyticsObj[RMAnalytics.CustomDimension.FLIGHT_PATH] = flightPath;

  var fltid1 = metaDict.airline + metaDict.flightNum;
  var fltid2 = metaDict.airline2 + metaDict.flightNum2;
  var fltid3 = metaDict.airline3 + metaDict.flightNum3;

  if (fltid1 !== "??????") {
    var flightIdentifier = fltid1;

    if (
      fltid3 !== fltid1 &&
      fltid3 !== fltid2 &&
      (metaDict.airline3 !== "???" || metaDict.flightNum3 !== "???")
    ) {
      flightIdentifier += ";" + fltid2 + ";" + fltid3;
    } else if (
      fltid2 !== fltid1 &&
      (metaDict.airline2 !== "???" || metaDict.flightNum2 !== "???")
    ) {
      flightIdentifier += ";" + fltid2;
    }

    analyticsObj[RMAnalytics.CustomDimension.FLIGHT_ID] = flightIdentifier;
  }

  return analyticsObj;
};

RMAnalytics.prototype.log = function (msg) {
  if (this.debugMode) {
    console.debug("[RM] " + msg);
  }
};
